import isEmpty from "lodash/isEmpty";

export const renderList = (items, noItemsText) => {
  if (isEmpty(items)) return noItemsText;

  return items
    .map(({ alias, label, name }) => alias || label || name)
    .join(", ");
};
